import { Api } from "@/core/services/api.service";
import { Category } from "@/apps/shared/catalog/core/domain/Category/Category";
import { storeCategoryToModel } from "@/apps/shared/catalog/core/infrastructure/mapper/categoryTreeMapper";
import { AxiosResponse } from "axios";
import useCategoryStore from "@/core/store/catalog/categoryStore";
import { MinimalCategory } from "@/apps/shared/catalog/core/domain/Category/MinimalCategory";

export type CategoryResponse = {
  id: string;
  label: string;
  identifier: string;
  children_description: string;
  children: CategoryResponse[] | string | null;
  image: { url: string; alt: string } | null;
  product_count?: { web: number; store: number };
};

export const getCategoryTree = async (): Promise<Category | null> => {
  const { categoryTree } = useCategoryStore();

  const storedCategoryTree = categoryTree;

  if (!storedCategoryTree) {
    return null;
  }

  return storeCategoryToModel(storedCategoryTree);
};

export const fetchCategoryTree = async (category?: Category): Promise<void> => {
  const getResource = category ? `/categories/tree/${category.id}` : `/categories/tree`;
  const { data }: AxiosResponse<CategoryResponse> = await Api.new().get(getResource);

  const { getStoreCategoryTree } = useCategoryStore();
  return getStoreCategoryTree(data, category);
};

export const fetchCategoryAncestry = async (category: Category): Promise<MinimalCategory[]> => {
  const { data }: AxiosResponse<{ id: string; label: string }[]> = await Api.new().get(
    `/internal/categories/${category.id}/ancestry`
  );

  return data.map(
    (categoryResponse: { id: string; label: string }) =>
      new MinimalCategory(categoryResponse.id, categoryResponse.label)
  );
};
